const Boxes = {
    box1: function () {
      var brd1 = JXG.JSXGraph.initBoard('jxgbox1',{boundingbox: [-7, 8, 6, -5],
    keepaspectratio: true, axis:true, ticks:{visible:false},
    grid:true, showCopyright:false, showNavigation:false,
    pan:{enabled:false}, zoom:{enabled:false}});
    brd1.options.layer['image'] =14;
brd1.create('text', [-6, 7., '<b> Balance of Moment <b>'],{CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(32*brd1.canvasWidth/500.)}, fixed:true});
brd1.create('text', [-6, 5.5, 'How many ways can the 1 kg, 3 kg and 5 kg weights be arranged on the right arm of the lever to balance the 10 kg weight on the left arm?'],{CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}, fixed:true});
brd1.create('text', [-6, 4.5, 'Place the weights on the lever arm. Then, move the palm away.'],{CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}, fixed:true});
//Order 
//brd1.options.layer['imcrane'] =1; 
//brd1.options.layer['seesaw'] =2; 
//
//Variables
var W1kg = 1;
var W3kg = 3;
var W5kg = 5;
var W10kg = 10;
var tt =0;
//
var support = brd1.create('point', [0, -0.35],
            {name:'', snapToGrid:false, 
            face:'^',size:20, strokeColor:'black', fillColor:'red', 
            fixed:true});
//
var Pt11 = brd1.create('point', [-5,0],{name:'', size:0, fixed:true});
var Pt1 = brd1.create('point', [-5,0],{name:'Pt1', size:0,withLabel:false, fixed:true});
var Pt0 = brd1.create('point', [0,0],{name:'Pt0', size:0,withLabel:false, fixed:true});
var p10kg = brd1.create('point', [-2, 0],{name:'', face:'square', size:2, strokeColor:'white', fillColor:'red'});

var p2 = brd1.create('point', [5, 0],{name:'p2', size:0,withLabel:false});
//seesaw
var seesaw = brd1.create('segment', [Pt1, p2],{strokeWidth:12, strokeColor:'black'});
var ang =brd1.create('angle', [Pt11,Pt0, p10kg],{visible:false});
//brd1.create('text', [-6, 3.5, function(){return ''+ ang.Value()*180/Math.PI+45;}],{CssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(14*brd1.canvasWidth/500.)}, fixed:true});
//Points on seesaw
var p00 = brd1.create('point', [0, 0],{name:'', size:2, strokeColor:'white', fillColor:'red', fixed:true});
var p01 = brd1.create('point', [1, 0],{name:'', size:2, strokeColor:'white', fillColor:'red', fixed:true});
var p02 = brd1.create('point', [2, 0],{name:'', size:2, strokeColor:'white', fillColor:'red', fixed:true});
var p03 = brd1.create('point', [3, 0],{name:'', size:2, strokeColor:'white', fillColor:'red', fixed:true});
var p04 = brd1.create('point', [4, 0],{name:'', size:2, strokeColor:'white', fillColor:'red', fixed:true});
var pm1 = brd1.create('point', [-1, 0],{name:'', face:'square', size:2, strokeColor:'white', fillColor:'red', fixed:true});
var pm2 = brd1.create('point', [-3, 0],{name:'', face:'square', size:2, strokeColor:'white', fillColor:'red', fixed:true});
var pm3 = brd1.create('point', [-4, 0],{name:'', face:'square', size:2, strokeColor:'white', fillColor:'red', fixed:true});
//Weight container
brd1.create('polygon',[[-15,-3.],[15,-3.],[15,-10],[-15, -10]], {fillColor:'grey', withLines:false, fillOpacity:1, vertices:{visible:false}, borders:{visible:false}});
//var im1kg = brd1.create('image', ['/assets/one.svg', [function(){return p1kg.X()-0.25},function(){return p1kg.Y()+0.1}], [0.5,0.5]],{rotate: function(){return ang.Value()*180/Math.PI}});
var i=function(){if(im1kg.Y()>=0){return 1} else{return 0}};
var j=function(){if(im3kg.Y()>=0){return 1} else{return 0}};
var k=function(){if(im5kg.Y()>=0){return 1} else{return 0}};
var im1kg = brd1.create('image', ['/assets/onekg.svg', [1, -3], [0.5,0.5]],{rotate:45,attractors: [p00, p01, p02, p03, p04], attractorDistance: 0.5, snatchDistance:0.25});
var im3kg = brd1.create('image', ['/assets/threekg.svg', [2, -3], [0.6,0.6]],{rotate:45, attractors: [p00, p01, p02, p03, p04], attractorDistance: 0.5, snatchDistance:0.25});
var im5kg = brd1.create('image', ['/assets/fivekg.svg', [3.2, -3], [0.8,0.8]],{rotate:45, attractors: [p00, p01, p02, p03, p04], attractorDistance: 0.5, snatchDistance:0.25});
var im10kg = brd1.create('image', ['/assets/tenkg.svg', [function(){return p10kg.X();},function(){return p10kg.Y();}], [1,1]],{rotate: function(){return 45+ang.Value()*180/Math.PI}});
//truck
//var t1 = brd1.create('point', [4, -1],{name:'t1', size:0,withLabel:false, fixed:true});
//var t2 = brd1.create('point', [8, -1],{name:'t2', size:0,withLabel:false, fixed:true});
//var lineTruck = brd1.create('segment', [t1,t2],{strokeWidth:1,dash:1, strokeColor:'black', fixed:true});
//var truck = brd1.create('glider', [4,-1, lineTruck], {face: 'o' , size:3, name:'Drag me', strokeColor:'black'});
//var lineTruck2 = brd1.create('segment', [function(){return truck.valueOf()},t2],{strokeWidth:1, strokeColor:'black', fixed:true});
//
var imtruck = brd1.create('image', ['/assets/right.svg', [-4.75, 0.5], [1.5,1.5]],{rotate:-90});
var res = brd1.create('image', ['/assets/reloading.svg', [-5.5,-2.5],[1, 1]], {opacity:1, fixed:true});

var distW1 =function() {
    if(im1kg.X()>=0 && im1kg.Y()==0){
        return im1kg.X();
    }
    else{
        return 0;
    }
}
//brd1.create('text', [2, 2, function(){return "DistW1 "+ distW1()}]);
var distW3 = function(){
    if(im3kg.X()>=0 && im3kg.Y()==0){
        return im3kg.X();
    }
    else{
        return 0;
    }
}
var distW5= function(){
    if(im5kg.X()>=0 && im5kg.Y()==0){
        return im5kg.X();
    }
    else{
        return 0;
    }
}
// ANGLE OF SEESAW
function angle (){
    if(W10kg.valueOf()*Math.abs(p10kg.X())-W1kg.valueOf()*distW1()-W3kg.valueOf()*distW3()-W5kg.valueOf()*distW5()>0) //10kg moment graeter
    { 
    return tt = Math.PI/8;
    }
    else if(W10kg.valueOf()*Math.abs(p10kg.X())-W1kg.valueOf()*distW1()-W3kg.valueOf()*distW3()-W5kg.valueOf()*distW5()<0) //Right moment graeter than 10kg moment 
    { 
       return tt= -Math.PI/8;
    }
     else
    { 
       return tt= 0;
    }
};
//MOVEMENT
imtruck.on('drag', function(){tt = angle();
    p2.moveTo([5*Math.cos(tt), 5*Math.sin(tt)], 1000);
    Pt1.moveTo([5*Math.cos(Math.PI+tt), 5*Math.sin(Math.PI+ tt)], 1000);
    p10kg.moveTo([2*Math.cos(Math.PI+tt), 2*Math.sin(Math.PI+ tt)], 1000);
	pm1.moveTo([1*Math.cos(Math.PI+tt), 1*Math.sin(Math.PI+ tt)], 1000);
	pm2.moveTo([3*Math.cos(Math.PI+tt), 3*Math.sin(Math.PI+ tt)], 1000);
	pm3.moveTo([4*Math.cos(Math.PI+tt), 4*Math.sin(Math.PI+ tt)], 1000);
    p01.moveTo([1*Math.cos(tt), 1*Math.sin(tt)], 1000);
    p02.moveTo([2*Math.cos(tt), 2*Math.sin(tt)], 1000);
    p03.moveTo([3*Math.cos(tt), 3*Math.sin(tt)], 1000);
    p04.moveTo([4*Math.cos(tt), 4*Math.sin(tt)], 1000);});
//	
imtruck.on('drag', function(){tt = angle();   
	if(distW1()>0){
    im1kg.moveTo([distW1()*Math.cos(tt), distW1()*Math.sin(tt)], 1000)};
});
//
imtruck.on('drag', function(){tt = angle(); 
	if(distW3()>0){
       im3kg.moveTo([distW3()*Math.cos(tt), distW3()*Math.sin(tt)], 1000)};
});
//
imtruck.on('drag', function(){tt = angle(); 
	if(distW5()>0){
       im5kg.moveTo([distW5()*Math.cos(tt), distW5()*Math.sin(tt)], 1000)};
});
res.on('down', function(){tt = 0;
    p2.moveTo([5*Math.cos(tt), 5*Math.sin(tt)]);
    Pt1.moveTo([5*Math.cos(Math.PI+tt), 5*Math.sin(Math.PI+ tt)]);
    p10kg.moveTo([2*Math.cos(Math.PI+tt), 2*Math.sin(Math.PI+ tt)]);
	pm1.moveTo([1*Math.cos(Math.PI+tt), 1*Math.sin(Math.PI+ tt)]);
	pm2.moveTo([3*Math.cos(Math.PI+tt), 3*Math.sin(Math.PI+ tt)]);
	pm3.moveTo([4*Math.cos(Math.PI+tt), 4*Math.sin(Math.PI+ tt)]);
    p01.moveTo([1*Math.cos(tt), 1*Math.sin(tt)]);
    p02.moveTo([2*Math.cos(tt), 2*Math.sin(tt)]);
    p03.moveTo([3*Math.cos(tt), 3*Math.sin(tt)]);
    p04.moveTo([4*Math.cos(tt), 4*Math.sin(tt)]);
    imtruck.moveTo([-4.75, 0.5]);
    im1kg.moveTo([1, -3]);    
    im3kg.moveTo([2, -3]);
    im5kg.moveTo([3.2, -3]);
    }
	);
im1kg.on('down', function(){imtruck.moveTo([-4.75, 0.5])});
im5kg.on('down', function(){imtruck.moveTo([-4.75, 0.5])});
im3kg.on('down', function(){imtruck.moveTo([-4.75, 0.5])});
      },
}
export default Boxes;
